<!-- src/app/app.component.html -->
<router-outlet />